










































































































































































import Vue from 'vue';
import { mapGetters } from 'vuex';
import CorrectionsBanner from '@/components/CorrectionsBanner.vue';
import ZeroStateCallToAction from '@/components/ZeroStateCallToAction.vue';
import CorrectionCard from '@/components/cards/CorrectionCard.vue';
import CorrectingCard from '@/components/cards/CorrectingCard.vue';
import SubjectCard from '@/components/cards/SubjectCard.vue';

export default Vue.extend({
  components: {
    CorrectionsBanner,
    ZeroStateCallToAction,
    CorrectionCard,
    CorrectingCard,
    SubjectCard,
  },
  computed: {
    ...mapGetters({
      corrections: 'corrections',
      correctingEssays: 'correctingEssays',
      highestScoresEssays: 'highestScoresEssays',
      examEssays: 'examEssays',
      highlightedSubjects: 'highlightedSubjects',
    }),
    showRecentCorrection(): boolean {
      // should also check if:
      // 1. user has not viewed Corrections.vue more than three times since last correction was made available
      // 2. user has not clicked in current correction
      return this.corrections.length > 1;
    },
  },
  created() {
    this.$store.dispatch('PULL_CORRECTING');
    this.$store.dispatch('PULL_CORRECTED');
  },
  methods: {
    sectionIsEmpty(section: any): boolean {
      return section.length === 0;
    },
    noEssaysYet(sections: Array<Array<Object>>): boolean {
      let objectsNotEmpty = sections.filter(section => section.length > 0);
      return objectsNotEmpty.length === 0;
    },
  },
});
